import type { User } from "@/app/services/generated/userService";
import { UserService } from "@/app/services/generated/userService";
import type Guid from "@/app/types/common/guid";

export class UserServiceExtended extends UserService {
  /** Accept null user because it makes the api between userStore and this service much nicer **/
  public hasPermission(user: User | null, ignored: any) {
    return user != null;
  }

  /**
   * Gets the users that are part of the tenant group that are not System or Support users.
   */
  public async getAllTenantGroupUsers(tenantGroupId: Guid): Promise<User[]> {
    return (await this.getAllUsers(tenantGroupId)).filter((u) =>
      this.isNotPremierUser(u)
    );
  }

  public async getAllUsersWithPremierUsersHidden(
    tenantGroupId: Guid
  ): Promise<User[]> {
    return (await this.getAllUsers(tenantGroupId)).map((u) => {
      u.isHidden = this.isNotPremierUser(u) ? u.isHidden : true;
      return u;
    });
  }

  public isNotPremierUser(user: User) {
    return !user.readOnly.isSupportUser && !user.readOnly.isSystemUser;
  }
}

export const userService = new UserServiceExtended();
